module.exports = __webpack_public_path__ + "img/gear-D_108x108.a5436405.png";